<template>
    <div v-if="filteredSearchData.length > 0" class="search-list-container" :class="{ 'mobile': getMobileAppState }">
        <div
        v-for="entry in filteredSearchData"
        class="entry"
        :key="entry.id"
        @click="navigateToPayment(entry)">
            <!-- Image -->
            <img :key="getAppThemeMode" class="row-image" :src="imageHandler(entry.image, entry)" @error="errorImage($event, entry)"/>
            <!-- Text: Entity or Type -->
            <div ref="rowTextRef" class="row-text">{{entry.text}}</div>
        </div>
    </div>
</template>

<script setup>
/* Vue */
import { ref, computed, watch } from 'vue'

/* Assets & Helpers */
import { categoryIconMapper, paymentsFlowsRoute } from '@/assets/scripts/mappers/payments'
import { navigateByName } from '@/router/helpers/navigation'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['showEmptyState'])

/* mapGetters */
const { getMobileAppState, getAppThemeMode } = mapGetters()

/** props received
@paymentsOperatorsList { Array } - Payments Operators List
@searchValue { String }
*/
const props = defineProps({
    paymentsOperatorsList: Array,
    searchValue: String
})

/* Data */
const rowTextRef = ref()

const searchData = computed(() => {
    const dataContainer = []

    props.paymentsOperatorsList.forEach(sector => sector.children.forEach(entity => entity.children.forEach(type => {
        dataContainer.push({
            categoryId: sector.categoryId,
            id: type.id,
            text: `${sector.name} / ${entity.name} / ${type.name}`,
            image: type.imageUrl,
            flow: type.flow,
            data: type.data,
            operatorInputs: type.operatorInputs
        })
    })))

    return dataContainer
})

const filteredSearchData = computed(() => {
    /* Turns the typed text of the searchValue in blue */
    /* eslint-disable */
    setTimeout(() => {
        var regEx = RegExp(props.searchValue, 'gi')
        if (rowTextRef.value) {
            rowTextRef.value.forEach(span => {
                span.innerHTML = span.innerText.replaceAll(regEx, word => {
                    return `<span style="font-weight: 600; color: var(--primary)">${word}</span>`
                })
            })
        }
    }, 0)

    return searchData.value.filter(el => el.text.toLowerCase().includes(props.searchValue.toLowerCase()))
})

watch(() => filteredSearchData.value, (newVal, oldVal) => {
    emit('showEmptyState', filteredSearchData.value.length === 0)
})

watch(() => props.searchValue, (newVal, oldVal) => {
    emit('showEmptyState', filteredSearchData.value.length === 0)
})

const navigateToPayment = entry => {
    navigateByName(paymentsFlowsRoute(entry.flow), { params: entry })
}

const imageHandler = (img, entry) => {
    return img || `./images${categoryIconMapper(entry.categoryId, getAppThemeMode.value === 'dark')}.svg`
}

const errorImage = (event, entry) => {
    event.target.src = `./images${categoryIconMapper(entry.categoryId, getAppThemeMode.value === 'dark')}.svg`
}

</script>

<style lang="scss" scoped>
.search-list-container {
    @include cardGeneral1;
    width: 100%;

    overflow: hidden;

    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    .entry {
        width: 100%;
        padding: 16px;

        display: flex;
        align-items: center;
        gap: 8px;

        border-radius: 8px;
        border: 1px solid var(--secondary-light-1);
        overflow: hidden;
        cursor: pointer;

        .row-image {
            width: 32px;
            height: 32px;

            display: flex;
            flex-shrink: 0;

            border-radius: 50%;
            border: 1px solid var(--secondary-light-2);
            background-color: var(--secondary-light-2);
            object-fit: scale-down;
        }

        .row-text {
            @include H7-Medium;
            color: var(--secondary-dark-2);

            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }
    }

    &.mobile {
        grid-template-columns: 1fr;

        .entry{
            display: flex;

            .entry-image-text {
                align-items: flex-start;
            }

            .row-text {
                @include H7-Medium;
                white-space: break-spaces;
                line-height: 16px;
            }

            .row-sector {
                text-align: left;
                padding: 7px 0 0 56px;
                margin: 0;

                font-size: 14px;
            }
        }
    }
}
</style>
